import React, { useRef, useEffect } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollToPlugin } from 'gsap/all';

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(ScrollToPlugin);

const SouthernLivingHero = () => {
  const heroRef = useRef(null);
  const headlineRef = useRef(null);
  const contentRef = useRef(null);
  const contentContainerRef = useRef(null);
  const overlayRef = useRef(null);
  const brandingRef = useRef(null);

  useEffect(() => {
    if (
      typeof window !== 'undefined' &&
      heroRef.current &&
      headlineRef.current &&
      contentRef.current
    ) {
      window.scrollTo({ top: 0, behavior: 'auto' });

      const mm = gsap.matchMedia();

      mm.add("(min-width: 900px)", () => {

        const tl = gsap.timeline({
          scrollTrigger: {
            trigger: heroRef.current,
            start: 'top top+=8.5%',
            end: `center center`,
            pin: true,
            scrub: false,
            toggleActions: 'play none none none',
          },
        },
        );

        tl.to(brandingRef.current, {
          height: '53px',
          ease: 'power2.out',
        })
          .fromTo(
            headlineRef.current,
            { opacity: 0, y: 40 },
            {
              opacity: 1,
              y: 0,
              ease: 'power2.out',
            },
            0.1
          )
          .fromTo(
            contentRef.current,
            { y: 180 },
            {
              y: 0,
              ease: 'power3.in',
            },
            0.2
          )
          .fromTo(
            contentContainerRef.current,
            { y: 220 },
            {
              y: 0,
            },
            0.3
          );
      });

      return () => {
        mm.revert();
      };
    }
  }, []);

  return (
    <section className="sl-hero" ref={heroRef}>
      <div className="sl-hero__video-wrap">
        <div className="sl-hero__video-container">
          <iframe
            src="https://player.vimeo.com/video/1100110229?background=1"
            allow="autoplay; fullscreen"
            loading="lazy"
            allowFullScreen
            title="Southern Living Hero Video"
            className="sl-hero__video"
          ></iframe>
        </div>
        <div className="sl-hero__overlay" ref={overlayRef}>
          <div className="sl-hero__branding" ref={brandingRef}>
            <img
              src="/wp-content/themes/wlion-2021/assets/images/Southern_Living_Logo-white.svg"
              alt="Southern Living"
              className='logo_sl'
              loading="lazy"
            />
            <img
              src="/wp-content/themes/wlion-2021/assets/images/plus-icon.svg"
              alt="plus icon"
              className='logo_plus'
              loading="lazy"
            />
            <img
              src="/wp-content/themes/wlion-2021/assets/images/PERC_Logo_2025-white.svg"
              alt="Propane Energy for Everyone"
              className='logo_perc'
              loading="lazy"
            />
          </div>
          <div className="sl-hero__wrapper">
            <h1 className="sl-hero__headline" ref={headlineRef}>
              From the Idea House to Your Home, Propane Powers Possibilities
            </h1>
          </div>
        </div>
      </div>

      <div className="sl-hero__content" ref={contentContainerRef}>
        <div className="sl-hero__block" ref={contentRef}>
          <h2>
            At the 2025 Southern Living Idea House, innovative and sustainable living is seamlessly powered by propane
          </h2>
          <p className='intro__desktop'>
            Nestled on a serene five acres near Charlottesville, Virginia, the 2025 Southern Living Idea House beautifully blends the local landscape with the comfort and convenience of modern amenities. The result is a timeless, inviting, and eco-friendly atmosphere that’s ideal for gatherings large or small, made possible by the power of propane. With propane, builders and homeowners have the freedom to build dream homes almost anywhere, regardless of access to natural gas mains or the electric grid.
          </p>
          <p className='intro__mobile'>
            The 2025 Southern Living Idea House beautifully blends the local landscape with the comfort and convenience of modern amenities. The result is a timeless, inviting, and eco-friendly atmosphere, made possible by the power of propane. With propane, homeowners have the freedom to build dream homes almost anywhere, regardless of access to other utilities.
          </p>
        </div>
      </div>
    </section>
  );
};

export default SouthernLivingHero;
